<template>
  <v-card class="panelBlock ma-2 conduct-terms">
    <v-layout
        row
        wrap>
      <v-flex class="administrator-tools__header" xs12>{{ myToolsConstants.ADMINISTRATOR_TOOLS }}</v-flex>
      <v-flex class="administrator-tools">
        <v-flex
            v-if="profileInformation.isRegionalOfficer"
            id="regional_redirect_sso"
            class="administrator-tools__list-items"
            text-xs-left
            xs12>
          <div class="links"
               data-qe-id="ssoLink"
               @click="handleNavigation(myToolsConstants.administrator_tools_links.regional_redirect_sso.link, linkTarget, myToolsConstants.administrator_tools_links.regional_redirect_sso.title)">
            {{ myToolsConstants.administrator_tools_links.regional_redirect_sso.title }}
          </div>
        </v-flex>
        <v-flex
            v-if="hasManagerAccess"
            id="manage_chapter_manager_community"
            class="administrator-tools__list-items"
            text-xs-left
            xs12>
          <a :href="myToolsConstants.administrator_tools_links.chapter_events_portal.link"
             class="links"
             :target="linkTarget">
            {{ myToolsConstants.administrator_tools_links.chapter_events_portal.title }}</a>
        </v-flex>
        <v-flex
            v-if="isChapterManager"
            id="manage_chapter_manager_community"
            class="administrator-tools__list-items"
            text-xs-left
            xs12>
          <a :href="myToolsConstants.administrator_tools_links.chapter_manager_community.link"
             class="links"
             :target="linkTarget">
            {{ myToolsConstants.administrator_tools_links.chapter_manager_community.title }}</a>
        </v-flex>
        <v-flex
            v-if="profileInformation.salesforceAccessfromExchange || profileInformation.isChapterForumOfficer"
            id="chapterManagementHub"
            class="administrator-tools__list-items"
            text-xs-left
            xs12>
          <a :href="myToolsConstants.administrator_tools_links.chapter_management_hub.link"
             :target="linkTarget"
             class="links"
             data-qe-id="chapterManagementhubLink"
             @click="trackLinkClick(myToolsConstants.administrator_tools_links.chapter_management_hub.title)">
            {{ myToolsConstants.administrator_tools_links.chapter_management_hub.title }}</a>
        </v-flex>
        <v-flex
            v-if="canViewChapterStudioPage"
            id="chapter_studio"
            class="administrator-tools__list-items"
            text-xs-left
            xs12>
             <a :href="myToolsConstants.administrator_tools_links.chapter_studio.link"
             class="links">
            {{ myToolsConstants.administrator_tools_links.chapter_studio.title }}</a>
        </v-flex>
        <v-flex
            v-if="hasTeamAccess"
            id="game_plan_request"
            class="administrator-tools__list-items"
            text-xs-left
            xs12>
            <a :href="myToolsConstants.administrator_tools_links.game_plan_request_form.link"
             :target="linkTarget"
             class="links"
             data-qe-id="chapterManagementhubLink"
             @click="trackLinkClick(myToolsConstants.administrator_tools_links.game_plan_request_form.title)">
            {{ myToolsConstants.administrator_tools_links.game_plan_request_form.title }}</a>
        </v-flex>
        <v-flex
            v-if="canViewManageChapterStudio"
            id="manage_chapter_studio"
            class="administrator-tools__list-items"
            text-xs-left
            xs12>
          <a :href="myToolsConstants.administrator_tools_links.manage_chapter_studio.link"
             class="links">
            {{ myToolsConstants.administrator_tools_links.manage_chapter_studio.title }}</a>
        </v-flex>
        <v-flex
            v-if="profileInformation.cventAccessfromExchange"
            id="cvent"
            class="administrator-tools__list-items"
            text-xs-left
            xs12>
          <div class="links"
               data-qe-id="ceventLink"
               @click="handleNavigation(myToolsConstants.administrator_tools_links.cvent.link, linkTarget, myToolsConstants.administrator_tools_links.cvent.title)">
            {{ myToolsConstants.administrator_tools_links.cvent.title }}
          </div>
        </v-flex>
        <v-flex
            v-if="isPRPAdmin && isActive"
            id="peerRevieewPanelAdmin"
            class="administrator-tools__list-items"
            text-xs-left
            xs12>
          <div class="links"
               data-qe-id="peer_review_panel_admin"
               @click="openPeerReviewPanel(myToolsConstants.administrator_tools_links.PEER_REVIEW_PANEL_ADMIN, myToolsConstants.administrator_tools_links.PEER_REVIEW_PANEL_ADMIN)">
            {{ myToolsConstants.administrator_tools_links.PEER_REVIEW_PANEL_ADMIN }}
          </div>
        </v-flex>
        <v-flex
            v-if="isPRPMember && isActive"
            id="peerRevieewPanel"
            class="administrator-tools__list-items"
            text-xs-left
            xs12>
          <div class="links"
               data-qe-id="peer_review_panel"
               @click="openPeerReviewPanel(myToolsConstants.administrator_tools_links.PEER_REVIEW_PANEL, myToolsConstants.administrator_tools_links.PEER_REVIEW_PANEL)">
            {{ myToolsConstants.administrator_tools_links.PEER_REVIEW_PANEL }}
          </div>
        </v-flex>
        <v-flex
            v-if="isChapterManager"
            id="workday"
            class="administrator-tools__list-items"
            text-xs-left
            xs12>
          <div class="links"
               data-qe-id="absorbLink"
               @click="handleNavigation(myToolsConstants.administrator_tools_links.workday.link, linkTarget, myToolsConstants.administrator_tools_links.workday.title)">
            {{ myToolsConstants.administrator_tools_links.workday.title }}
          </div>
        </v-flex>
      </v-flex>
    </v-layout>
  </v-card>
</template>

<script>
import { myToolsConstants } from "./mytools.constant.js";
import { mapActions, mapGetters } from "vuex";
import { storeGetters } from '../../store/storeGetters.constant';
import { storeAction } from '../../store/storeActions.constant';
import { gaDataLayerEvent } from "@/plugins/analytics";
import { gtmEventName } from "@/plugins/gtmAnalytics";
import { userTypes } from "../MyAccount/myaccount.constants.js";

export default {
  name: "AdministratorTools",
  data: () => ({
    myToolsConstants,
    regionalDirector: 'Regional Director',
    networkDirector: 'Network Director',
    chaptersRegionCommunityManager: 'Chapters & Regions Community Manager',
  }),
  props: {
    showHideTools: {
      type: Function,
    },
  },
  created() {
    this.getCanViewSpeakerAdminDirectory();
  },
  components: {},
  methods: {
    openPeerReviewPanel(route, title) {
      if (this.showHideTools) this.showHideTools();
      if (route === this.myToolsConstants.administrator_tools_links.PEER_REVIEW_PANEL_ADMIN) {
        this.$router.push({
          path: '/peerReviewPanelAdmin',
        });
      } else if (route === this.myToolsConstants.administrator_tools_links.PEER_REVIEW_PANEL) {
        this.$router.push({
          path: '/peerReviewPanel',
        });
      }
      this.trackLinkClick(title);
    },
    ...mapActions({
      getCanViewSpeakerAdminDirectory: `speaker/${storeAction.getCanViewSpeakerAdminDirectory}`,
    }),

    openSpeakerAdministration(title) {
      if (this.showHideTools) this.showHideTools();
      this.$router.push({
        path: `/speakerPage/speakerAdministration`,
        query: {
          pendingApplicants: true,
        },
      });
      this.trackLinkClick(title);
    },
    handleNavigation(url, target, title) {
      const appOrigin = window.location.origin;
      if (url && !url.includes('http')) {
        url = `https://${url}`;
      }
      if (url.includes(appOrigin)) {
        window.open(url, "_self");
      } else {
        window.open(url, target);
      }
      this.trackLinkClick(title);
    },
    trackLinkClick(title) {
      gaDataLayerEvent(gtmEventName.C_Resource_Page_Resource_link, `${title}`);
    },
  },
  computed: {
    ...mapGetters({
      profileInformation: `myAccount/${storeGetters.profileInformation}`,
      canViewSpeakerAdminDirectory: `speaker/${storeGetters.canViewSpeakerAdminDirectory}`,
      prpRole: `chapterWaiver/${storeGetters.prpRole}`,
      isMobileAppBrowser: `${[storeGetters.isMobileAppBrowser]}`,
      isPRPAdmin: `chapterWaiver/${storeGetters.isPRPAdmin}`,
      isPRPMember: `chapterWaiver/${storeGetters.isPRPMember}`,
      isActive: `chapterWaiver/${storeGetters.isActive}`,
      canViewChapterStudioPage: `auth/${storeGetters.canViewChapterStudioPage}`,
      canViewManageChapterStudio: `auth/${storeGetters.canViewManageChapterStudioPage}`,
      userPermissionsData: `auth/${storeGetters.permissionsData}`,
      usersCommunitiesList: `chapter/${storeGetters.usersCommunitiesList}`,
      isChaptersAndRegionsTeamMember: `auth/${storeGetters.isChaptersAndRegionsTeamMember}`,
      userProfile: `memberProfile/${storeGetters.userProfile}`,
    }),
    linkTarget() {
      return this.isMobileAppBrowser ? '_self' : '_blank';
    },

    isChapterManager() {
      return this.profileInformation.recordTypeName === this.myToolsConstants.CHAPTER_ADMIN || this.profileInformation.recordTypeName === this.myToolsConstants.CHAPTER_MANAGER;
    },
    isTeamMember() {
      return this.userPermissionsData && this.userPermissionsData.userRoles && this.userPermissionsData.userRoles.some(o => o === userTypes.TEAM_MEMBER_PRODUCT_MANAGEMENT);
    },
    isRegionalDirector() {
      return (
        Array.isArray(this.usersCommunitiesList) &&
        this.usersCommunitiesList.some(
          x => Array.isArray(x.roles) && x.roles.includes(this.regionalDirector)
        )
      );
    },
    isNetworkDirector() {
      return (
        Array.isArray(this.usersCommunitiesList) &&
        this.usersCommunitiesList.some(
          x => Array.isArray(x.roles) && x.roles.includes(this.networkDirector)
        )
      );
    },
    hasTeamAccess() {
        return this.isChapterManager || this.isTeamMember || this.isRegionalDirector || this.isNetworkDirector || this.isChaptersAndRegionsTeamMember;
    },
    isCommunityManager() {
        return this.userProfile.businessTitle === this.chaptersRegionCommunityManager;
    },
    hasManagerAccess() {
      return this.isChapterManager || this.isCommunityManager || this.isChaptersAndRegionsTeamMember;

    }
    },
};
</script>

<style lang="scss">
@import "../../common/styles/_colors.scss";
@import "../../common/styles/_responsive.scss";

.administrator-tools {
  border: none;

  &__header {
    padding: 5px 15px;
    font-family: 'Raleway', sans-serif;
    color: $ypo-blue;
    font-size: 18px;
    line-height: 34px;
    font-weight: 500;
    border-bottom: 1px solid rgba($ypo-gray, 0.4);
  }

  &__list-items {
    text-align: left;
    padding: 7px 0 0 !important;
    line-height: 16px;
  }

  .links {
    text-decoration: none;
    transition: 0.3s;
    font-size: 12px;
    font-weight: 500;
    color: $ypo-cta;
    display: inline-block;
    cursor: pointer;

    &:hover {
      text-decoration: underline;
      color: $ypo_blue;
    }
  }
}
</style>
